module.exports = __webpack_public_path__ + "assets/img/29_288_big.ab4793a2.jpg";